export default "__VITE_ASSET__WhMIhGiculOwCBlAQORV$w__"